import {
    call,
    put,
    all,
    StrictEffect,
    takeLatest,
    fork,
    cancelled,
    cancel,
    select,
    delay,
} from 'redux-saga/effects';
import { fetchAPI, getApi } from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';

import { setAllDataSUCCESS } from '@Redux/search/All/action';
import { setGroupDataSUCCESS } from '@Redux/search/Group/action';
import { setHotelDataSUCCESS } from '@Redux/search/Hotel/action';
import { setVocationDataSUCCESS } from '@Redux/search/Vacation/action';
import { setTicketDataSUCCESS } from '@Redux/search/Ticket/action';
import { setFlightDataSUCCESS } from '@Redux/search/Flight/action';

// todo 可參考註解簡易版 saga流程
// function* setPopularinfoAsync(
//     action: actions.I_PopularinfoAction
// ): Generator<StrictEffect, any, any> {
//     const PopularInfo = yield call(fetchAPI, {
//         url: `${detailRoute}/popularinfojson`,
//         req: action.payload,
//     });
//     yield put(actions.setPopularinfoSUCCESS(PopularInfo));
// }

// function* watchsetPopularinfoAsync() {
//     yield takeLatest(actionTypes.SET_POPULARINFO, setPopularinfoAsync);
// }

// 全產品資料抓取
function* setDataAsync(action: actions.I_SetGetDataAction): Generator<StrictEffect, any, any> {
    let recommendParams = '';
    let ApiData;
    const hasRecommend = yield select((state) => {
        return state.search.reducer.RecommendsData;
    });
    let SuccessFilterInfo = setAllDataSUCCESS;
    switch (action.payload.apiUrl) {
        case 'searchtravel':
            SuccessFilterInfo = setGroupDataSUCCESS;
            recommendParams = 'grp';
            break;
        case 'searchhotel':
            SuccessFilterInfo = setHotelDataSUCCESS;
            recommendParams = 'htl';
            break;
        case 'searchvacation':
            SuccessFilterInfo = setVocationDataSUCCESS;
            recommendParams = 'vac';
            break;
        case 'searchactivity':
            SuccessFilterInfo = setTicketDataSUCCESS;
            recommendParams = 'etk';
            break;
        case 'searchflight':
            SuccessFilterInfo = setFlightDataSUCCESS;
            recommendParams = 'flt';
            break;
        default:
            SuccessFilterInfo = setAllDataSUCCESS;
            recommendParams = '';
    }
    try {
        ApiData = yield call(
            getApi,
            `${DomainByEnv()}/json/${action.payload.apiUrl}?${action.payload.params}`
        );
    } catch (error) {
        // 錯誤時轉發recommand的api，card清空
        yield cancel(ApiData);
    } finally {
        if (yield cancelled()) {
            console.log("doesn't expected error");
        }
    }
    // let ApiData = fork(apiCall, action.payload.apiUrl, action.payload.params, recommendParams);
    if (ApiData.DataDetail.Total == 0) {
        //卡牌無資料時call推薦api
        yield fork(getRecommendData, action.payload.params, recommendParams);
    } else if (hasRecommend.length > 0) {
        yield put(actions.setRecommends([]));
    }
    if (ApiData.DataFilter.PriceMax != 0 || ApiData.DataFilter.DestinationList.length > 0) {
        // 用共同資料"金額 或是有 目的地資料"判別要不要設定篩選資料(預設最大金額是1塊，但若是1塊filter面板可能不會出現)
        yield put(SuccessFilterInfo(ApiData.DataFilter)); //篩選
    }

    yield put(actions.setCardInfo(ApiData.DataDetail)); //卡牌
    yield put(actions.setFilterDataLoading(false));
}

function* watchDataAsync() {
    yield takeLatest(actionTypes.GET_DATA, setDataAsync);
}

function* getRecommendData( // 推薦卡牌api
    params: string,
    recommendParams: string
): Generator<StrictEffect, any, any> {
    const sliceKeywordIndex = params.indexOf('Keyword');
    const sliceKeyword = params.slice(sliceKeywordIndex);
    try {
        const recommend = yield call(
            getApi,
            `${DomainByEnv()}/json/recommendation?ProductType=${recommendParams}&${sliceKeyword}`
        );
        yield put(actions.setRecommends(recommend));
        yield put(actions.setFilterDataLoading(false));
        yield put(actions.setSendEmitApi(true));
    } catch (error) {
        console.log('recommand data fail');
        return [];
    }
}

// 收藏提示框
function* setFavPopUp(action: actions.I_FavPopUpAction) {
    yield put(actions.setShowFavPopUp(action.payload));
    yield delay(1500);
    yield put(actions.setHideFavPopUp());
}
function* watchSetFavPopUpAsync() {
    yield takeLatest(actionTypes.SET_FAVPOPUP, setFavPopUp);
}

export default function* rootSaga() {
    yield all([
        // watchsetPopularinfoAsync(),
        watchDataAsync(),
        watchSetFavPopUpAsync(),
    ]);
}
